import { Section, CodeWrapper, NcaLink, Table } from 'nca-acquiring-theme';
import { openSearchConfigSnippet, openSearchConnectionConfigurationSnippet, openSearchIndexCreationSnippet, openSearchIndexNameSnippet } from "../../../../src/snippets/openSearchSnippets";
import { TransactionSearchSupportedFieldsTable } from "../../../../src/snippets/transaction-search-table";
import * as React from 'react';
export default {
  Section,
  CodeWrapper,
  NcaLink,
  Table,
  openSearchConfigSnippet,
  openSearchConnectionConfigurationSnippet,
  openSearchIndexCreationSnippet,
  openSearchIndexNameSnippet,
  TransactionSearchSupportedFieldsTable,
  React
};